export enum TableDisplayMode {
    ResponsiveTable,
    ResponsiveCards,
    Table,
}
